import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import type { Bundle } from "@memorang/types";
import type { BundleMetaData } from "@memorang/types";
import { commerceBasePath } from "./constants";
import type { CreateCheckoutSessionResponse } from "./types";
export async function fetchProductDetails({
	tenantId,
	numericId,
}: {
	tenantId: string;
	numericId: number;
}): Promise<Bundle> {
	// TODO(backend): derive tenantId from JWT claims; reject body tenantId once server-side auth enforces it.
	const { data } = await authAxios.post(
		`${API_BASE_URL}/aibl-query/get-product-details`,
		{
			numericId,
			tenantId,
		},
	);

	return data.data.productDetails;
}

export async function fetchProductMetadata({
	tenantId,
	productId,
	userId,
}: {
	tenantId: string;
	productId: string;
	userId: string;
}): Promise<BundleMetaData> {
	// TODO(backend): derive userId/tenantId from JWT claims; remove body userId once backend enforces caller match.
	const { data } = await authAxios.post(
		`${API_BASE_URL}/aibl-query/get-product-metadata`,
		{
			productId,
			tenantId,
			userId,
		},
	);

	return data.data;
}

export async function createCheckoutSession({
	userId,
	payment,
}: {
	userId: string;
	payment: {
		productId: string;
		quantity: number;
		planId: number;
		successUrl: string;
		cancelUrl: string;
	};
}): Promise<CreateCheckoutSessionResponse> {
	const { data } = await authAxios.post(
		`${API_BASE_URL}/${commerceBasePath}/product/checkout`,
		{
			payment,
			userId,
		},
	);

	return data.data;
}
